import type { BlockFragment } from "@ihr-radioedit/inferno-webapi";

export abstract class BaseStoreBlock {
  abstract currentBlock: BlockFragment | undefined;
  abstract storeBlock(block: BlockFragment): void;
}
